{
  "ResourcePortalBookingSidebar": {
    "booking": "预订",
    "dates": "日期",
    "tasks": "任务",
    "note": "备注",
    "noNoteLeft": "未留备注",
    "files": "文件",
    "comingSoon": "即将推出"
  },
  "ResourcePortalMenu": {
    "portalFor": "为……提供门户网站",
    "routes": {
      "calendar": "日历",
      "bookings": "预订",
      "details": "详情"
    }
  },
  "CalendarRoute": {
    "anErrorOccurred": "发生错误",
    "leaveWithoutSubmittingChanges": "您确定要在不提交更改的情况下离开吗？",
    "shareAvailability": "{{resourceFullName}}，请与{{companyUserFirstName}}（{{companyName}}）共享您的空闲时间",
    "successShareTitle": "可用时间已发送",
    "successShare": " {{companyName}} 的{{companyUserFirstName}}将收到关于您即将有空的通知",
    "gotItThanks": "知道了，谢谢",
    "availabilityBetween": "{{companyUserFirstName}} 想了解您在 {{startDate}}到{{endDate}} 之间的空闲时间。",
    "shareInstruction": "请选择以下状态以填写日历，分享您的空闲时间。",
    "submitCalendar": "提交日历",
    "today": "今天",
    "allDay": "全天",
    "perDay": "每天可用 {{hours}}h{{mins}} / 天",
    "unavailable": "不可用",
    "daily": " 每天",
    "availabilityAssignedCannotEdit": "该可用时间已分配生产，无法编辑",
    "mobileHint": {
      "title": "添加可用时间",
      "intro": "使用日历管理可用时间段：",
      "items": {
        "selectStatus": "选择可用或不可用，然后长按并拖过日期以添加时间段。",
        "adjustHours": "点按已添加的时间段，可设置全天、每天小时数或具体时间。",
        "moveOrResize": "拖动现有时间段可移动它，或拖动边缘来延长或缩短日期范围。"
      },
      "open": "显示可用时间帮助",
      "dismiss": "知道了"
    },
    "status": {
      "AVAILABLE": "可用",
      "UNAVAILABLE": "不可用"
    },
    "tooltip": {
      "actionView": "点击查看",
      "actionEdit": "点击编辑",
      "cannotEdit": "无法编辑",
      "notEditable": "不可编辑",
      "availableAllDay": "全天可用",
      "availableForHours": "每天可用 {{hours}} 小时",
      "availableSpecificHours": "每天 {{start}} - {{end}} 可用",
      "deleteAvailability": "删除可用时间"
    },
    "cannotEditModal": {
      "title": "无法编辑状态",
      "message": "只有预订所有者可以编辑此状态。如果您需要更改此状态，请联系协调您预订的人员。",
      "dismiss": "关闭"
    },
    "availabilityEditDialog": {
      "title": "配置可用时间",
      "description": "编辑可用时间",
      "saveChanges": "保存更改"
    }
  },
  "BookingsRoute": {
    "comingSoon": "即将推出",
    "description": "查看您与{{companyName}}的当前和以前的预订",
    "details": "跟踪已确认的预订，并关注发票和付款状态。"
  },
  "ContactDetailsRoute": {
    "comingSoon": "即将推出",
    "description": "当您的联系方式有变时，请通知{{companyName}}",
    "details": "通过此门户提交新的联系信息并执行其他有用的操作。"
  }
}
